import { AxiosResponse } from "axios";
import { api, CustomAxiosRequestConfig, ENDPOINTS } from "@app/api";
import { AnnouncementsRequestDef } from "@app/types/announcements.types";

const PLATFORM_HEADER = { headers: { PLATFORM: "WEBAPP" } };

export const apiCreateAnnouncement = (payload: any): Promise<AxiosResponse> => {
  return api.post(ENDPOINTS.createAnnouncement, payload);
};

export const apiGetAnnouncements = (): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.getAnnouncements, {
    ...PLATFORM_HEADER,
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGetTranslationPermissions = (): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.getTranslationPermissions);
};

export const apiDownloadTranslationsZip = (
  platform: string,
): Promise<AxiosResponse<Blob>> => {
  return api.get(ENDPOINTS.exportTranslationsZip, {
    params: { platform },
    responseType: "blob",
  });
};

export const apiCreateTranslation = (payload: any) => {
  return api.post(ENDPOINTS.createTranslation, payload);
};

export const apiUpdateTranslation = (payload: any) => {
  return api.put(ENDPOINTS.updateTranslation, payload);
};

export const apiBulkUpdateTranslations = (payload: any) => {
  return api.put(ENDPOINTS.bulkUpdateTranslations, payload);
};

export const apiDeleteTranslation = (translationId: string) => {
  return api.delete(`${ENDPOINTS.deleteTranslation}/${translationId}`);
};

export const apiDownloadTranslationsXlsx = (
  platform: string,
  fileName: string,
): Promise<AxiosResponse<Blob>> => {
  return api.get(ENDPOINTS.exportTranslationsXlsx, {
    params: { platform, fileName },
    responseType: "blob",
  });
};

export const apiDownloadTranslationsSqlWeb = (
  platform: string,
  payload: any,
): Promise<AxiosResponse<Blob>> => {
  return api.post(ENDPOINTS.exportTranslationsSqlWeb, payload, {
    params: { platform },
    responseType: "blob",
  });
};

export const apiDownloadTranslationsSqlApi = (
  payload: any,
): Promise<AxiosResponse<Blob>> => {
  return api.post(ENDPOINTS.exportTranslationsSqlApi, payload, {
    responseType: "blob",
  });
};
export const apiDownloadTranslationsSqlMobile = (
  payload: any,
): Promise<AxiosResponse<Blob>> => {
  return api.post(ENDPOINTS.exportTranslationsSqlMobile, payload, {
    responseType: "blob",
  });
};

export const apiImportDBTranslations = () => {
  return api.post(ENDPOINTS.apiImportDBTranslations);
};

export const apiGetGlobalAnnouncements = (
  params: AnnouncementsRequestDef,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.getGlobalAnnouncements, {
    ...PLATFORM_HEADER,
    params,
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGetAnnouncementsPopups = async (): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.getPopupAnnouncements, {
    PLATFORM_HEADER,
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGetUnreadCountAnnouncements = (): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.getUnreadCountAnnouncements, {
    PLATFORM_HEADER,
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGetGlobalAnnouncementPermissions =
  (): Promise<AxiosResponse> => {
    return api.get(ENDPOINTS.getGlobalAnnouncementPermissions, PLATFORM_HEADER);
  };

export const apiDeleteAnnouncements = (
  announcementIds: string[],
): Promise<AxiosResponse> => {
  return api.delete(ENDPOINTS.deleteAnnouncement, {
    data: { announcementIds },
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiDeleteGlobalAnnouncements = (
  announcementIds: string[],
): Promise<AxiosResponse> => {
  return api.delete(ENDPOINTS.deleteAnnouncementGlobal, {
    data: { announcementIds },
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiMarkReadAnnouncements = (
  announcementIds: string[],
): Promise<AxiosResponse> => {
  return api.put(ENDPOINTS.announcementMarkRead, { announcementIds }, {
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiHideMultipleAnnouncementPopup = (
  announcementIds: string[],
): Promise<AxiosResponse> => {
  return api.put(ENDPOINTS.hideMultipleAnnouncementPopup, { announcementIds });
};

export const apiGetOtherAnnouncementsTemplate = (): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.getOtherAnnouncementsTemplate);
};
